import { request } from '@pb/utils'

export const fetchCart = (): any => request.get(`carts`).then((res) => res.data)

/**
 * Returns same response as 'carts' but without availability check towards SAP CAR (faster performance, for e.g. Black Friday)
 */
export const fetchMinicart = (): any => request.get(`minicart`).then((res) => res.data)

export const fetchOneClickCheckoutInfo = (): any =>
  request.get(`oneClickCheckout`).then((res) => res.data)

export const createPayPalExpressToken = (): any =>
  request.post(`payPalExpress/token`).then((res) => res.data)

export const deleteCartItem = (variantCode): any =>
  request.delete(`carts/items/${variantCode}`).then((res) => res.data)

export const updateQuantity = (variantCode, quantity): any =>
  request
    .put(`carts/items/${variantCode}`, {
      data: { quantity },
    })
    .then((res) => res.data)

export const fetchClubOfferDetails = (promotionCode): any =>
  request
    .get(`member/offers.clubofferdetail.${promotionCode}`, {
      type: 'adobe',
    })
    .then((res) => res.data)

export const performOneClickCheckout = (shouldSkipModal, pageAttributes): any =>
  request
    .post('oneClickCheckout', {
      data: { occConfirmed: shouldSkipModal, ...(pageAttributes && { pageAttributes }) },
    })
    .then((res) => res.data)

export const performConfirmOneClickCheckout = (data): any =>
  request.post('confirmOcc', { data }).then((res) => res.data)
